import { useSuspenseQuery } from "@apollo/client";

import { MapEditorObservationMediaPointPanelEditableDocument } from "./queries.generated";

export function useSuspenseObservationMediaPointQuery(mapEditorFeatureId: string) {
    return useSuspenseQuery(MapEditorObservationMediaPointPanelEditableDocument, {
        variables: { mapEditorFeatureId },
    });
}
